import { EnhancedStore } from '@reduxjs/toolkit'
import { store } from '@dtx-company/inter-app/src/redux/store'
import { useState } from 'react'

export const useInitializeReduxStore = (): Readonly<[EnhancedStore]> => {
  return useState(() => {
    return [store] as const
  })[0]
}
